import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=d8b8e31e&scoped=true"
import script from "./TextEdit.vue?vue&type=script&lang=js"
export * from "./TextEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b8e31e",
  null
  
)

export default component.exports